export default "__VITE_ASSET__DsZJ77P1__"